import { Information, Button } from 'ui';
import { useTranslation } from '@/i18n/client';

import styles from './SuccessScreen.module.scss';
import { SuccessScreenProps } from './types';

export const SuccessScreen = ({ email, type, backToLoginPress }: SuccessScreenProps) => {
	const { t } = useTranslation(['header', 'common']);

	return (
		<div className={styles.successScreen__Wrapper}>
			<h2 className={styles.successScreen__title}>{t('common:common.success')}!</h2>
			<Information type="success" className={styles.successScreen__information}>
				{type === 'remindPassword'
					? t('authModal.remindPasswordSuccessInformation', { email })
					: t('authModal.signUpSuccessInformation', { email })}
			</Information>
			<p className={styles.successScreen__caption}>{t('authModal.remindPasswordSuccessCaption')}</p>
			<ul className={styles.successScreen__list}>
				<li className={styles['successScreen__list--item']}>
					{t('authModal.remindPasswordSuccessCheckSpam')}
				</li>
				<li className={styles['successScreen__list--item']}>
					{t('authModal.remindPasswordSuccessCorrectEmail')}
				</li>
				<li className={styles['successScreen__list--item']}>
					{t('authModal.remindPasswordSuccessWaitAndCheckAgain')}
				</li>
			</ul>
			<Button variant="iconButton" buttonName="backToLoginButton" onPress={backToLoginPress}>
				{t('authModal.backToLogin')}
			</Button>
		</div>
	);
};
